<template>
    <div>
        <a-modal v-model="visible" title="渠道授权" :confirm-loading="confirmLoading" @ok="handleOk"   width="750px">
            <p>通道名称：{{passwayItem.passwayname}}</p>
             <a-spin :spinning="spinning_">
                <a-row>
                    <a-col :span="12" class="box_left">
                        <p>可选渠道</p>
                        <div class="item_box">
                            <div class="item_self"  v-for="(item,index) in unauthedList" :key="index">{{item.channelname}}<a-icon @click="handlePluss(item)" class="box_icon"  type="plus-square" /></div>
                        </div>
                    </a-col>
                    <a-col :span="12" class="box_right">
                        <p>已授权渠道</p>
                        <div class="item_box">
                            <div class="item_self" v-for="(item,index) in authedList" :key="index">{{item.channelname}}<a-icon @click="handleMinus(item)" class="box_icon" type="minus-square" /></div>
                        </div>
                    </a-col>
                </a-row>
            </a-spin>
        </a-modal>
    </div>
</template>
<script>

export default {
    data() {
        return {
            visible:false,
            confirmLoading:false,
            spinning_:false,
            authedList:[],
            unauthedList:[],
            passwayItem:{
                passwaycode:'',
                passwayname:''
            }
        };
    },
    methods: {
        showModal(passwayItem) {
            let that = this;
            that.passwayItem = passwayItem;
            //获取已授权和未授权列表
            that.spinning_ = true;
            that.$store.dispatch({
                type: "mcmsmanager/selectauthchannel",
                params: {
                    passwaycode:passwayItem.passwaycode,
                    passwaytype:passwayItem.passwaytype
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.authedList = result.filter((item) => { return item.authed == '1' });
                    that.unauthedList = result.filter((item) => { return item.authed == '0' });

                }
                that.spinning_  = false;
            });
            //显示对话框
            that.visible = true;
        },
        handleOk() {
            //处理成字符串
            let that = this;
            let resultArray = [];
            that.authedList.forEach(element => {
                resultArray.push(element.channelcode); 
            });
            that.confirmLoading = true;
            that.$store.dispatch({
                type: "mcmsmanager/updateauthchannel",
                params: {
                    passwaycode:that.passwayItem.passwaycode,
                    passwaytype:that.passwayItem.passwaytype,
                    channelcodes:resultArray.join(',')
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    console.log(result)
                    this.visible = false;
                }
                that.confirmLoading  = false;
            });
        },
        handlePluss(channelItem){
            //未授权 - 已授权
            this.authedList.push(channelItem);
            this.unauthedList = this.unauthedList.filter((item) => {return item.channelcode != channelItem.channelcode})
        },
        handleMinus(channelItem){
            //已授权 -  未授权
            this.unauthedList.push(channelItem);
            this.authedList = this.authedList.filter((item) => {return item.channelcode != channelItem.channelcode})
        }
    },
    props:{
    }
};
</script>

<style lang="less" scoped>
    .box_left,
    .box_right{
        border:1px solid lightgray;
        padding: 20px;
    }

    .box_right{
        border-left: none;

    }

    .item_box{
        width: 100%;
        height:300px;
        overflow-y: scroll;
        padding-right:20px;
    }

    .item_self{
        width:100%;
        height: 30px;
        margin:4px 0;
        padding-left:4px;
        line-height: 30px;
    }

    .box_left p,
     .box_right p{
        color: black;
        font-weight: bolder;
        text-align: center;
        font-size: 18px;
    }

    // .item_self:hover{
    //     // background-color: lightskyblue;
    //     // color: white;
    // }

    .box_icon{
        float: right;
        font-size: 24px;
        line-height: 32px;
        color: #1890ff;
        cursor: pointer;
    }
</style>
